// checkInConfig

export const checkInConfig = {
  accessCode: process.env.REACT_APP_CHECK_IN_ACCESS_CODE,
};